import { render, staticRenderFns } from "./HeadItem.vue?vue&type=template&id=372664b9&scoped=true"
import script from "./HeadItem.vue?vue&type=script&lang=js"
export * from "./HeadItem.vue?vue&type=script&lang=js"
import style0 from "./HeadItem.vue?vue&type=style&index=0&id=372664b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372664b9",
  null
  
)

export default component.exports